import { schema } from 'normalizr';

export const locationSchoolSchema = new schema.Entity('locationSchool');
export const locationSchoolListSchema = [locationSchoolSchema];
